import initialState from './initialState';
import {
  FETCH_GL_ACCOUNTS_SUCCESS,
  FETCH_GL_ACCOUNTS_FAILURE,
  FETCH_TAXENTRY_TYPES_SUCCESS,
  FETCH_TAXENTRY_TYPES_FAILURE,
  FETCH_TAXENTRY_ACTIVITIES_SUCCESS,
  FETCH_TAXENTRY_ACTIVITIES_FAILURE,
  FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS,
  FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE,
  FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS,
  FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE,
  FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL,
  FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED,
} from './types';

const glJournalsReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_GL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        glAccounts: payload.glAccounts,
      };
    case FETCH_GL_ACCOUNTS_FAILURE:
      return {
        ...state,
        glAccounts: initialState.glAccounts,
      };
    case FETCH_TAXENTRY_TYPES_SUCCESS:
      return {
        ...state,
        types: payload.types,
      };
    case FETCH_TAXENTRY_TYPES_FAILURE:
      return {
        ...state,
        types: initialState.types,
      };
    case FETCH_TAXENTRY_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: payload.activities,
      };
    case FETCH_TAXENTRY_ACTIVITIES_FAILURE:
      return {
        ...state,
        activities: initialState.activities,
      };
    case FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS:
      return {
        ...state,
        slAccounts: payload.slAccounts,
      };
    case FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE:
      return {
        ...state,
        slAccounts: initialState.slAccounts,
      };
    case FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS:
      return {
        ...state,
        slTaxEntries: payload.slTaxEntries,
      };
    case FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE:
      return {
        ...state,
        slTaxEntries: initialState.slTaxEntries,
      };
    case FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: true,
      };
    case FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: false,
      };
    default:
      return state;
  }
};

export default glJournalsReducer;
